<template>
  <div v-if="internalValue" :class="computedClasses">
    <div class="p-alert-wrapper">
      <div grow class="p-alert-main">
        <p-icon class="p-alert-icon" :color="computedColor + '-darken-3'">
          {{ computedTypeIcon }}
        </p-icon>
        <div class="slot-wrapper">
          <slot></slot>
        </div>
      </div>
      <div class="p-alert-dismissable">
        <p-button v-if="dismissable" class="p-alert-close-button" :color="computedColor + '-lighten-2'" dense @click="onCloseClick">
          <p-icon dense :color="computedColor + '-darken-2'">
            close
          </p-icon>
        </p-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import mixins from '../../mixins';

  export default mixins().extend({
    props: {
      value: { default: false, type: undefined },
      dismissable: { default: false, type: Boolean },
      type: { default: 'info', type: String },
      outline: { default: false, type: Boolean },
      flat: { default: false, type: Boolean },
      elevation: { default: 0, type: Number },
      spacious: { default: false, type: Boolean },
      dense: { default: false, type: Boolean },
    },
    watch: {
      value: {
        immediate: true,
        handler() {
          this.internalValue = (this.value as boolean);
        },
      },
    },
    computed: {
      computedColor(): string {
        if (!this.type) {
          return 'info';
        }
        if (this.type.toLowerCase() === 'validation') {
          return 'error';
        }
        return this.type;
      },
      computedTypeIcon(): string | undefined {
        if (!this.type) {
          return 'info';
        }
        if (this.type.toLowerCase() === 'success') {
          return 'check_circle';
        }
        if (this.type.toLowerCase() === 'information') {
          return 'info';
        }
        if (this.type.toLowerCase() === 'error') {
          return 'priority_high';
        }
        if (this.type.toLowerCase() === 'validation') {
          return 'error_outline';
        }
        return this.type;
      },
      computedClasses(): {} {
        return {
          'p-alert': true,
          'input-error': this.type?.toLowerCase() === 'validation',
          [`elevation-${this.elevation}`]: !this.flat,
          [`text-color-${this.computedColor}`]: true,
          [`border-color-${this.computedColor}`]: true,
          outline: this.outline,
          spacious: this.spacious,
          dense: this.dense,
        };
      },
    },
    data: () => ({
      internalValue: true,
    }),
    methods: {
      onCloseClick() {
        this.internalValue = false;
        this.$emit('input', false);
      },
    },
  });
</script>
